import { createContext, useContext } from "react";
import { TokenResponse } from '@api/Responses/KeycloakTokenResponse';

interface AuthenticationContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  entry: (data: TokenResponse) => Promise<void>;
  login: (data: { username: string, password: string, sellerEmailOrPhone?: string }) => Promise<void>;
  logout: () => void;
  setIsAuthenticated_: (value: (((prevState: boolean) => boolean) | boolean)) => void
}

const AuthenticationContext = createContext<AuthenticationContextType | null>(
  null,
);

export const useAuth = (): AuthenticationContextType => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error("useAuth must be used within an ProfileProvider");
  }
  return context;
};

export default AuthenticationContext;
export { default as AuthenticatedProvider } from "./AuthenticatedProvider";
